import { render, staticRenderFns } from "./TournamentDetail.vue?vue&type=template&id=57f02778&"
import script from "./TournamentDetail.vue?vue&type=script&lang=js&"
export * from "./TournamentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports